import { useMemo } from "react";
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
} from "cdbreact";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import isAdministrator, { isStaff } from "../utilities/checkPrivileges";

// Navigation items configuration
const NAV_ITEMS = [
  {
    to: "/",
    icon: "th-large",
    label: "Dashboard",
  },
  {
    to: "/all",
    icon: "laptop",
    label: "Devices",
  },
  {
    to: "/applications",
    icon: "book",
    label: "Applications",
  },
  {
    to: "/profiles",
    icon: "clipboard",
    label: "Profiles",
  },
  {
    to: "/ddm",
    icon: "sliders-h",
    label: "DDM",
    adminOnly: true,
  },
  {
    to: "/software-updates",
    icon: "arrow-circle-up",
    label: "Software Updates",
  },
  {
    to: "/night-rest",
    icon: "moon",
    label: "Nachtruhe",
  },
  {
    to: "/mac-scripts",
    icon: "code",
    label: "Mac-Skripte",
    adminOnly: true,
  },
  {
    to: "/mac-packages",
    icon: "box",
    label: "Mac-Pakete",
    adminOnly: true,
  },
  {
    to: "/classroom",
    icon: "chalkboard-teacher",
    label: "Klassenraum",
    staffOnly: true,
  },
  {
    to: "/users",
    icon: "users",
    label: "Users",
  },
  {
    to: "/locations",
    icon: "map-marker-alt",
    label: "Locations",
  },
  {
    to: "/device-groups",
    icon: "layer-group",
    label: "Geräte-Gruppen",
  },
  {
    to: "/device-registrations",
    icon: "clipboard-list",
    label: "Geräte-Registrierung",
  },
  {
    to: "/dep-profiles",
    icon: "id-card",
    label: "DEP-Profile",
    adminOnly: true,
  },
  {
    to: "/settings",
    icon: "cog",
    label: "Einstellungen",
    adminOnly: true,
  },
];

export default function Sidebar() {
  const { user } = useSelector((state) => state.auth);

  const renderNavItems = useMemo(() => {
    const admin = isAdministrator();
    const staff = isStaff();
    return NAV_ITEMS.filter(({ adminOnly, staffOnly }) => {
      if (adminOnly) return admin;
      if (staffOnly) return staff;
      return true;
    }).map(({ to, icon, label }) => (
      <NavLink 
        key={to} 
        to={to} 
        className={({ isActive }) => 
          isActive ? "activeClicked" : undefined
        }
      >
        <CDBSidebarMenuItem icon={icon}>
          {label}
        </CDBSidebarMenuItem>
      </NavLink>
    ));
  }, []);

  if (!user) {
    return null;
  }

  return (
    <aside className="sidebar h-screen">
      <CDBSidebar 
        textColor="#fff" 
        className="bg-dark min-h-screen"
      >
        <CDBSidebarHeader 
          prefix={
            <i className="fa fa-bars fa-large hover:opacity-80 transition-opacity" />
          }
        >
          <NavLink 
            to="/" 
            className="text-decoration-none hover:opacity-80 transition-opacity"
            style={{ color: "inherit" }}
          >
            <span className="font-semibold">Admin Portal</span>
          </NavLink>
        </CDBSidebarHeader>

        <CDBSidebarContent className="sidebar-content">
          <CDBSidebarMenu>
            {renderNavItems}
          </CDBSidebarMenu>
        </CDBSidebarContent>
      </CDBSidebar>
    </aside>
  );
}
